import React, { useEffect, useState } from "react";
import { Accordion, AccordionItem } from "@heroui/react";
import Header from "../Layouts/Header.jsx";
import MarketList from "./MarketList.jsx";
import { Spinner } from "@heroui/react";
import { TimeIcon } from "../../components/HeaderSidebarIcons.jsx";
 
const Markets = () => {
  const [groupedMarkets, setGroupedMarkets] = useState({});
  const [loading, setLoading] = useState(true);
 
  useEffect(() => {
    // Show spinner for 1 second on mount
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);
 
  useEffect(() => {
    const getEvents = async (e) => {
      // setLoadingEvents(true);
      // Set headers with JWT token
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));
      // Request body
      const urlencoded = {
        // "event_id": props.event_id,
      };
      // API request options
      let requestOptions = {
        method: "GET",
        headers: headers,
        // body: JSON.stringify(urlencoded),
      };
      // Fetch API Call
      fetch(
        process.env.REACT_APP_API_HOST + "/match",
        requestOptions
      )
        .then((response) => {
          if (response.status === 401) {
            console.log("Unauthorized access. Please log in again.");
          } else {
            return response.json();
          }
        })
        .then((result) => {
          if (result.data) {
            const grouped = groupData(result.data);
            setGroupedMarkets(grouped);
            // setEventList(result.data);
          }
        })
        .catch((err) => {
          console.log("Error fetching events:", err);
        })
        .finally(() => {
          // setLoadingEvents(false);
        });
    };
    getEvents();
  }, []);
 
  const groupData = (data) => {
    const result = {};
    data.forEach((item) => {
      const { market_name, match_name } = item;
      if (!result[market_name]) {
        result[market_name] = {};
      }
      if (!result[market_name][match_name]) {
        result[market_name][match_name] = [];
      }
      result[market_name][match_name].push(item);
    });
    return result;
  };
 
  if (loading) {
    return (
      <div className="h-screen">
        <Header />
        <div className="flex items-center justify-center min-h-screen">
          <Spinner size="lg" variant="spinner" />
        </div>
      </div>
    );
  }
 
  return (
    <div className="h-screen">
      <Header />
 
      <div className="px-1 mx-auto max-w-screen-xl md:max-w-screen-2xl 2xl:max-w-screen-lg lg:py-5 ">
        {Object.keys(groupedMarkets).length > 0 ? (
          <div>
            {Object.entries(groupedMarkets).map(([marketName, matches]) => (
              <div className="py-1">
                <div className="w-full bg-m_peach text-m_black mb-1">
                  <h1 className="px-3 py-1 font-semibold">{marketName}</h1>
                </div>
                <MarketList marketName={marketName} matches={matches} />
               
              </div>
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center h-96">
            <div className="text-center">
              <h2 className="text-xl font-semibold text-gray-600">
                No Markets Available
              </h2>
            </div>
          </div>
        )}
      </div>
 
      {/* <div className="px-1 mx-auto max-w-screen-xl md:max-w-screen-2xl 2xl:max-w-screen-xl lg:py-7">
        <div className="flex items-center bg-white rounded border border-m_gray shadow-md text-[12px] leading-[12px] my-[5px] px-2 py-4">
          <div className="w-1/4 text-center">
            <a
              href="#"
              className="text-gray-700"
              data-toggle="modal"
              data-target="#gameTimeModal1"
            >
              <i className="fa fa-clock-o"></i>
              <br />
              Game Time
            </a>
          </div>
 
          <div className="w-1/2">
            <div className="text-center">
              <span className="block font-semibold text-gray-800">
                TIME BAZAR
              </span>
              <p className="text-red-500 text-[11px]">
                Betting is Closed for Today
              </p>
              <span className="block font-medium text-gray-700">
                250-79-270
              </span>
            </div>
          </div>
 
          <div className="w-1/4 text-center">
            <a href="#" className="text-gray-500">
              <i className="fa fa-play-circle"></i>
              <br />
              Play Game
            </a>
          </div>
        </div>
      </div> */}
      {/* <div className="px-1 mx-auto max-w-screen-xl md:max-w-screen-2xl 2xl:max-w-screen-2xl lg:py-6">
          {Object.keys(groupedMarkets).length > 0 ? (
            <Accordion
              key={Object.keys(groupedMarkets)[0]}
              defaultExpandedKeys={[Object.keys(groupedMarkets)[0]]}
            >
              {Object.entries(groupedMarkets).map(([marketName, matches]) => (
                <AccordionItem
                  key={marketName}
                  title={
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 border-l-4 border-m_green">
                        <img
                          src="/img/madhur.png"
                          alt={`${marketName}-icon`}
                          className="w-8 h-8 object-contain"
                        />
                      </div>
                      <h2 className="font-semibold">{marketName}</h2>
                    </div>
                  }
                  hideIndicator
                >
                  <MarketList marketName={marketName} matches={matches} />
                </AccordionItem>
              ))}
            </Accordion>
          ) : (
            <div className="flex items-center justify-center h-96">
              <div className="text-center">
                {/* <img
                  src="/img/no-data.png"
                  alt="No Data"
                  className="w-24 h-24 mx-auto mb-4"
                /> */}
      {/* <h2 className="text-xl font-semibold text-gray-600">
                  No Markets Available
                </h2>
              </div>
            </div>
          )}
        </div>  */}
    </div>
  );
};
export default Markets;
 
 